import type { Shop } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useLazyQuery, useQuery } from '@apollo/client'

export interface ShopsQuery {
  shops: Shop[]
}

export interface ShopsVariables {}

export const GQL_QUERY_SHOPS = gql`
  query {
    shops {
      id
      name
      address
      phone
      status
      minOrderCost
      workingHours
      tzOffset
      shopOpenTime
      shopCloseTime
    }
  }
`

export const useFetchShops = (variables?: ShopsVariables) =>
  useQuery<ShopsQuery, ShopsVariables>(GQL_QUERY_SHOPS, {
    variables,
    fetchPolicy: 'network-only'
  })

export const useLazyFetchShops = (variables?: ShopsVariables) => 
  useLazyQuery<ShopsQuery, ShopsVariables>(GQL_QUERY_SHOPS, {
    variables
  })
